import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Clock, CheckCircle } from 'lucide-react';
import TimeTracking from './TimeTracking';
import TimeValidation from './TimeValidation';

const HeuresPage = () => {
  const { user } = useAuth();
  
  // Nannies see only time tracking (no validation rights)
  if (user?.role === 'nanny') {
    return <TimeTracking />;
  }
  
  // Parents see both: time tracking (pointage) + validation
  return (
    <div className="container-custom py-6 space-y-6" data-testid="heures-page-parent">
      <div>
        <h1 className="text-3xl font-bold" style={{ fontFamily: 'var(--font-secondary)' }}>
          Gestion du temps
        </h1>
        <p className="text-[var(--text-secondary)] mt-1">
          Pointez les heures et validez les entrées
        </p>
      </div>
      
      <Tabs defaultValue="pointage" className="w-full">
        <TabsList className="w-full md:w-auto h-auto p-1" style={{ backgroundColor: 'var(--neutral-100)' }}>
          <TabsTrigger 
            value="pointage" 
            className="gap-2 text-sm py-2 data-[state=active]:bg-[var(--bg-primary)] data-[state=active]:text-[var(--primary-400)] data-[state=active]:shadow-sm" 
            data-testid="tab-pointage"
          >
            <Clock className="h-4 w-4" />
            Pointage
          </TabsTrigger>
          <TabsTrigger 
            value="validation" 
            className="gap-2 text-sm py-2 data-[state=active]:bg-[var(--bg-primary)] data-[state=active]:text-[var(--primary-400)] data-[state=active]:shadow-sm" 
            data-testid="tab-validation"
          >
            <CheckCircle className="h-4 w-4" />
            Validation
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="pointage" className="mt-4">
          <TimeTracking embedded />
        </TabsContent>
        
        <TabsContent value="validation" className="mt-4">
          <TimeValidation embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default HeuresPage;
